<template>
  <Header />
  <router-view/>
  <Footer />
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  created() {
    if (window.location.hostname === 'good-edition.com'
      || window.location.hostname.endsWith('.good-edition.com')) {
      // サブドメイン部分を抽出して置き換え
      const newHostname = window.location.hostname.replace('good-edition.com', 'japan-edition.com');
      const port = window.location.port ? `:${window.location.port}` : '';
      const newUrl = `${window.location.protocol}//${newHostname}${port}${window.location.pathname}${window.location.search}${window.location.hash}`;
      window.location.replace(newUrl);
    }
  },
};

</script>

<style lang="scss">
@import '@/assets/scss/reset.scss';
@import '@/assets/scss/_mq.scss';
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_fonts.scss';
@import '@/assets/scss/transition.scss';
@import '@/assets/scss/modal.scss';
@import '@/assets/scss/style.scss';
</style>
